import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  Card,
  Col,
  Form,
  Row,
  Spinner,
  Dropdown,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import CustomNavbar from "../../../components/CustomNavbar";
import CustomTable from "../../../components/CustomTable";
import CustomPagint from "../../../components/CustomPagint";
import config from "../../../config";

import SidebarClimate from "../../../components/Clima/SidebarClimate";
import { getClimaLog } from "../../../redux/climalaboral/climaLog/actions";

const ClimaLog = () => {
  const filters = [
    { id: "action", desc: "Acción" },
    { id: "modelo", desc: "Mantenimiento" },
    { id: "empleado_nombre", desc: "Creado por" },
    // { id: "fecha_creacion", desc: "Fecha creación" },
  ];

  const [tipoBusqueda, setTipoBusqueda] = useState(filters[0]);

  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState("");
  const [show, setShow] = useState(false);

  const dispatch = useDispatch();

  const { loading, climaLog, climaLogError } = useSelector(
    (store) => store.climaLog
  );
  const pages = Math.ceil(climaLog ? climaLog.count / limit : 0);

  const columns = [
    {
      Header: "Acción",
      accessor: "action",
      Filter: "",
      Cell: (value) => (
        <div style={{ minWidth: "180px" }}>
          {
            config.accion_log.find(
              (m) => m.action === value.row.original.action
            ).accion
          }
        </div>
      ),
    },
    {
      Header: "Mantenimiento",
      accessor: "modelo",
      Filter: "",
      Cell: (value) => (
        <div style={{ minWidth: "180px" }}>
          {
            config.modelo_log.find(
              (m) => m.modelo === value.row.original.modelo
            ).mantenimiento
          }
        </div>
      ),
    },
    {
      Header: "Data",
      accessor: "data",
      Filter: "",
    },
    {
      Header: "Creado por",
      accessor: "empleado",
      Filter: "",
      Cell: (value) => (
        <div style={{ minWidth: "140px" }}>
          {value.row.original.info_empleado[0].nombre}
        </div>
      ),
    },
    {
      Header: "Fecha creación",
      accessor: "fecha_creacion",
      Filter: "",
      Cell: (value) => (
        <div style={{ minWidth: "140px" }}>
          {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
        </div>
      ),
    },
  ];

  // Métodos
  const _getClimaLog = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getClimaLog({
        offset: offs,
        limit: lim,
        tipo_busqueda: tipoBusqueda.id,
        filter:
          tipoBusqueda.id === "fecha_creacion"
            ? filt !== ""
              ? !isNaN(filt)
                ? filt
                : `${filt.charAt(6)}${filt.charAt(7)}${filt.charAt(
                    8
                  )}${filt.charAt(9)}-${filt.charAt(3)}${filt.charAt(
                    4
                  )}-${filt.charAt(0)}${filt.charAt(1)}`
              : filt
            : filt,
      })
    );

  useEffect(() => {
    _getClimaLog();
  }, []);

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getClimaLog(oOffset, limit, e.target.filter.value);
  };

  const onSearchSelect = (e) => {
    e.preventDefault();
    // if (!e.currentTarget.value.trim()) {
    //   return;
    // }
    setFilter(e.currentTarget.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getClimaLog(oOffset, limit, e.currentTarget.value);
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getClimaLog(oOffset, limit, oSearch);
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarClimate show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h6 className="font-weight-bold text-uppercase">
              Registro actividades
            </h6>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-sm-end align-items-center flex-nowrap">
                {/* <Col xs="auto">
                  <Form.Control
                    name="filter"
                    id="filter"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    type="search"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle"
                    >
                      <i className="material-icons">list</i>
                    </Button>
                  </ButtonGroup>
                </Col> */}
                <Col>
                  <h6>
                    <b>Búsqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  {tipoBusqueda.id === "action" ||
                  tipoBusqueda.id === "modelo" ? (
                    <Form.Control
                      as="select"
                      name="filter"
                      id="filter"
                      placeholder="Buscar"
                      className="rounded-pill form-control-sm"
                      onChange={onSearchSelect}
                      style={{ minWidth: "174px" }}
                    >
                      <option
                        className="text-muted"
                        key={0}
                        value=""
                        //  selected
                        //  disabled
                      ></option>
                      {tipoBusqueda.id === "action" &&
                        config.accion_log.map((item) => (
                          <>
                            <option key={item.action} value={item.action}>
                              {item.accion}
                            </option>
                          </>
                        ))}
                      {tipoBusqueda.id === "modelo" &&
                        config.modelo_log.map((item) => (
                          <>
                            <option key={item.modelo} value={item.modelo}>
                              {item.mantenimiento}
                            </option>
                          </>
                        ))}
                    </Form.Control>
                  ) : (
                    <Form.Control
                      name="filter"
                      id="filter"
                      placeholder="Buscar"
                      className="rounded-pill form-control-sm"
                      type="search"
                    ></Form.Control>
                  )}
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle mr-1"
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    <Dropdown className="mx-1">
                      <Dropdown.Toggle
                        variant="light"
                        className="btn-sm font rounded-pill"
                      >
                        <i className="material-icons">filter_list</i>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {filters.map((item) => (
                          <Dropdown.Item
                            onClick={() => setTipoBusqueda(item)}
                            key={item.id}
                          >
                            {item.desc}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            climaLog &&
            climaLog.count > 0 && (
              <>
                <Card className="border-0">
                  <Card.Body className="px-1 px-sm-2">
                    <CustomTable columns={columns} data={climaLog.data} />
                  </Card.Body>
                </Card>
                <CustomPagint
                  limit={limit}
                  setLimit={setLimit}
                  offset={offset}
                  setOffset={setOffset}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  dataLenght={climaLog.count}
                  pages={pages}
                  pagFunc={_getClimaLog}
                />
              </>
            )
          )}
          {!loading &&
            climaLog &&
            climaLog.count === 0 &&
            climaLogError === "" && (
              <Alert variant="info" className="my-4">
                Aún no hay registros, comience agregando algunos
              </Alert>
            )}
          {!!climaLogError && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {climaLogError}
            </Alert>
          )}
        </Container>
      </div>
    </>
  );
};

export default ClimaLog;
